import { Link } from "react-router";
import { Badge, Mono, PageHeader, Td, Tr } from "../../ui/index.tsx";
import { PagedPanel, When } from "./_ops.tsx";
import type { AuditEntry } from "../../../shared/types.ts";

export default function Audit() {
  return (
    <>
      <PageHeader title="Audit log" description="Every admin write, newest first." />
      <PagedPanel<AuditEntry>
        base="/admin/audit"
        limit={50}
        searchPlaceholder="Search action, admin, target or details"
        emptyTitle="No audit entries"
        emptyIcon="scroll"
        columns={["When", "Admin", "Action", "Target", "Details"]}
        renderRow={(a) => (
          <Tr key={a.id}>
            <Td><When at={a.created_at} /></Td>
            <Td className="whitespace-nowrap">{a.admin_username ?? <span className="text-faint">system</span>}</Td>
            <Td><Badge>{a.action}</Badge></Td>
            <Td className="whitespace-nowrap">
              {a.target_username && a.target_id
                ? <Link to={`/admin/users/${a.target_id}`} className="font-medium hover:text-accent hover:underline">{a.target_username}</Link>
                : a.target_id ? <Mono>{a.target_id}</Mono> : <span className="text-faint">—</span>}
            </Td>
            <Td className="max-w-md break-words text-muted">{a.details || "—"}</Td>
          </Tr>
        )}
      />
    </>
  );
}
